// extracted by mini-css-extract-plugin
export default {"root":"ClientForm_root__nPEVW","fullWidth":"ClientForm_fullWidth__Wiz5P"};